const Routes = {
  login: "/login",
  home: "/",
  hats: "/hats",
  jackets: "/jackets",
  sneakers: "/sneakers",
  checkout: '/checkout'
};

export default Routes;
